<template>
    <div class="row">
        <form @submit.prevent="currentTimeslot ? updateTimeslot() : addNewTimeslot()">
            <div class="panel panel-primary">
                <div class="panel-heading">Add New Timeslot</div>
                <div class="panel-body" v-if="form">
                    <div class="form-group row">
                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                            <label>Name</label>
                            <input class="form-control" v-model="form.timeslot_name" placeholder="Timeslot Name" />
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                            <label>Number required</label><br>
                            <input type="number" class="form-control" v-model="form.number_required">
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                            <label>Hours</label><br>
                            <input type="number" class="form-control" v-model="form.hours">
                        </div>
                    </div>
                </div>
                <div class="panel-footer">
                    <button type="submit" class="btn btn-success pull-right">{{ buttonLabel }}</button>
                </div>
            </div>
        </form>
    </div>
</div>
</template>

<script>
    import Form from '../utils/Form';

    export default {
        props: [
            'eventId',
            'jobId',
            'currentTimeslot'
        ],

        data: function () {
            return {
                form: new Form({
                    timeslot_name: this.currentTimeslot ? this.currentTimeslot.timeslot_name : null,
                    number_required: this.currentTimeslot ? this.currentTimeslot.number_required : null,
                    hours: this.currentTimeslot ? this.currentTimeslot.hours : true
                }),
                buttonLabel: this.currentTimeslot ? 'Update Timeslot' : 'Save New Timeslot'
            };
        },

        methods: {
            addNewTimeslot() {
                this.form.post(`/api/v1/club_events/${this.eventId}/jobs/${this.jobId}/timeslots`)
                    .then(response => {
                        this.$emit('timeslot-changed');
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem saving the timeslot.', type: 'error'});
                    });
            },

            updateTimeslot() {
                this.form.put(`/api/v1/club_events/${this.eventId}/jobs/${this.jobId}/timeslots/${this.currentTimeslot.id}`)
                    .then(response => {
                        this.$emit('timeslot-changed');
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem saving the timeslot.', type: 'error'});
                    });
            }
        },

        destroyed() {
            this.form = null;
        }
    }
</script>
